import React from "react"
import numeral from "numeral"

export default class CurrencyDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    const data = (this.props.data || 0) / 100
    const currency_format = this.props.currency_unit + '0' + this.props.delimiter + '0' + this.props.separator + '00'
    const formatted_data = numeral(data).format(currency_format)

    if (data < 0) {
      return (
        <div className="negative-amount" align="right">
          ({formatted_data.substring(1)})
        </div>
      );
    } else {
      return (
        <div align="right">{formatted_data}</div>
      );
    }
  }

};
